import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QuillEditor = ({
  register,
  value,
  name,
  label,
  maxLength,
  onChangeFunction,
  readOnly,
  required = false,
}) => {
  return (
    <>
      <ReactQuill
        className="focus:shadow-none border text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
        value={value || ""}
        readOnly={readOnly}
        onChange={(content) => onChangeFunction(content)}
        theme="snow"
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }], // Add options for headings
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            // ['code-block'],
            ["link", "image"],
          ],
        }}
      />
      <input
        readOnly={readOnly}
        type="hidden"
        {...register(`${name}`, {
          required: required && !value ? `${label} is required!` : false,
        })}
        name={name}
        maxLength={200}
        autoComplete="off"
        value={value || ""}
      />
    </>
  );
};

export default QuillEditor;
